import { saveAs } from 'file-saver';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OrderService, ProceedStepService, AttachmentService } from '@app/api/api';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'meu-app-my-order',
  templateUrl: './app-my-order.component.html',
  styleUrls: ['./app-my-order.component.scss'],
})
export class AppMyOrderComponent implements OnInit {
  constructor(
    private orderService: OrderService,
    private ref: ChangeDetectorRef,
    private toastr: ToastrService,
    private proceedStepService: ProceedStepService,
    private attachmentService: AttachmentService,
    private http: HttpClient
  ) {}
  lstMyOrder: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
  displayedColumns: string[] = ['code', 'date', 'name', 'money', 'status', 'bill'];
  totalMyOrder: any;
  pagesize: any = 10;
  pageIndex: any = 1;
  allListMyOrder: any = [];

  lstProceedSelected: any = [];
  dateSlected: any = {};
  proceedSteps: any = [];
  filterStringCompare;
  searchStr$ = new Subject();
  searchStr: any = '';
  isFirstLoad = true;

  ngAfterViewInit() {
    this.getAllProcessStep();
  }

  ngOnInit() {
    this.searchStr$.pipe(debounceTime(300)).subscribe((value) => {
      this.searchStr = value || '';
      this.getAllMyOrder();
    });
  }
  ngOnDestroy() {
    this.ref.detach();
  }
  downloadInvoice(id) {
    this.orderService.apiOrdersIdDownloadInvoiceGet(id).subscribe(
      (res) => {
        saveAs(res);
      },
      (err) => {
        this.toastr.error('Không có hoá đơn');
      }
    );
  }

  downloadDocument(orderId: string, document: any) {
    if (!document || !document.id) {
      this.toastr.error('Không tìm thấy thông tin file.');
      return;
    }
    const downloadUrl = `${environment.backendhost}/api/orders/${document.id}/downloadFinancial`;
    window.open(downloadUrl, '_blank');
  }

  private triggerDownload(url: string, fallbackFilename: string) {
    this.http.get(url, { responseType: 'blob', observe: 'response' }).subscribe(
      (response: any) => {
        const contentType = response.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const res = JSON.parse(reader.result as string);
              this.toastr.error(res.message || 'Không thể tải file.');
            } catch (e) {
              this.toastr.error('Không thể tải file.');
            }
          };
          reader.readAsText(response.body);
          return;
        }

        let filename = fallbackFilename;
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition) {
          const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (utf8Match) {
            filename = decodeURIComponent(utf8Match[1]);
          } else {
            const simpleMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
            if (simpleMatch) { filename = simpleMatch[1].trim(); }
          }
        }
        const blobUrl = window.URL.createObjectURL(response.body);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      },
      (err) => {
        console.error(err);
        if (err.error instanceof Blob && err.error.type.includes('application/json')) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const res = JSON.parse(reader.result as string);
              this.toastr.error(res.message || 'Không thể tải file.');
            } catch (e) {
              this.toastr.error('Không thể tải file.');
            }
          };
          reader.readAsText(err.error);
        } else {
          this.toastr.error('Không thể tải file.');
        }
      }
    );
  }

  downloadReceiptPdf(orderId: string, userId: string) {
    if (!orderId) { this.toastr.error('Không tìm thấy mã đơn hàng.'); return; }
    const query = userId ? `?userId=${userId}` : '';
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${orderId}/receipt-pdf${query}`,
      `bien-ban-bao-gia-${orderId}.pdf`
    );
  }

  downloadQuotationPdf(orderId: string, userId: string, voucherValue: number = 0) {
    if (!orderId) { this.toastr.error('Không tìm thấy mã đơn hàng.'); return; }
    let query = userId ? `?userId=${userId}` : '';
    if (voucherValue) {
      query += (query ? '&' : '?') + `voucher_value=${voucherValue}`;
    }
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${orderId}/quotation-pdf${query}`,
      `chao-gia-${orderId}.pdf`
    );
  }

  downloadReceiptExcel(orderId: string, userId: string) {
    if (!orderId) { this.toastr.error('Không tìm thấy mã đơn hàng.'); return; }
    const query = userId ? `?userId=${userId}` : '';
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${orderId}/receipt-excel${query}`,
      `bien-ban-bao-gia-${orderId}.xlsx`
    );
  }

  downloadQuotationExcel(orderId: string, userId: string, voucherValue: number = 0) {
    if (!orderId) { this.toastr.error('Không tìm thấy mã đơn hàng.'); return; }
    let query = userId ? `?userId=${userId}&isVat=true` : '?isVat=true';
    if (voucherValue) {
      query += `&voucher_value=${voucherValue}`;
    }
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${orderId}/quotation-excel${query}`,
      `chao-gia-${orderId}.xlsx`
    );
  }

  downloadContractWord(orderId: string, userId: string, voucherValue: number = 0) {
    if (!orderId) { this.toastr.error('Không tìm thấy mã đơn hàng.'); return; }
    let query = userId ? `?userId=${userId}` : '';
    if (voucherValue) {
      query += (query ? '&' : '?') + `voucher_value=${voucherValue}`;
    }
    this.triggerDownload(
      `${environment.backendhost}/api/orders/${orderId}/contract-word${query}`,
      `hop-dong-${orderId}.docx`
    );
  }

  getAllMyOrder() {
    if (this.isFirstLoad) return;

    let filter = this.searchStr
      ? `(extend_product_name|code|phone|extend_company_tax_code)@=${this.searchStr}`
      : '';

    if (this.lstProceedSelected && this.lstProceedSelected.length > 0) {
      let proceedLength = this.lstProceedSelected.length;
      let selectedStr = '';
      this.lstProceedSelected.map((item, i) => {
        selectedStr = selectedStr + item;
        if (proceedLength === i + 1) {
          return;
        }
        selectedStr = selectedStr + '|';
      });
      filter = filter + (filter ? ',' : '') + `step_id==${selectedStr}`;
    }

    this.dateSlected.startDate && this.dateSlected.endDate
      ? (filter =
          filter +
          (filter ? ',' : '') +
          `created_at >= ${moment(this.dateSlected.startDate).format(
            'DD/MM/YYYY'
          )},created_at <= ${moment(this.dateSlected.endDate).add(1, 'days').format('DD/MM/YYYY')}`)
      : filter;

    this.filterStringCompare !== filter ? (this.pageIndex = 1) : null;

    this.filterStringCompare = filter;

    this.orderService.apiMyOrdersGet(filter, '', this.pageIndex, this.pagesize).subscribe((res) => {
      if (res.success) {
        this.allListMyOrder = res.data.collection;
        this.pageIndex = res.data.pageIndex;
        this.pagesize = res.data.pagesize;
        this.totalMyOrder = res.data.total;
        this.loadFinancialDocuments();
        this.ref.detectChanges();
      }
    });
  }

  loadFinancialDocuments() {
    this.allListMyOrder.forEach((order) => {
      this.http.get<any>(`${environment.backendhost}/api/orders/${order.id}/financialDocument`).subscribe(
        (res) => {
          if (res.success && res.data && res.data.length > 0) {
            order.extend_financial_documents = res.data;
            this.ref.detectChanges();
          }
        },
        (err) => {
          console.error('Error loading financial documents for order', order.id, err);
        }
      );
    });
  }
  paginatorChange(event) {
    this.pagesize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.getAllMyOrder();
  }
  moment(date) {
    return moment.utc(date).local().format('DD/MM/YYYY');
  }

  onKeyUp(value) {
    this.searchStr$.next(value);
  }
  preventDefault(e) {
    e.preventDefault();
  }

  getAllProcessStep() {
    this.proceedStepService.apiProceedStepsGet('', 'sort_order').subscribe((res) => {
      if (res.success) {
        this.proceedSteps = res.data.collection;
        this.proceedSteps.map((item) => {
          // !item.is_done ? this.lstProceedSelected.push(item.id) : void 0;
          this.lstProceedSelected.push(item.id);
        });

        this.isFirstLoad = false;
        this.getAllMyOrder();
      }
    });
  }
}
